<template>
  <v-container class="pt-3">
    <v-app-bar app dense color="white" flat>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <v-avatar><img :src="user.profile_picture" referrerpolicy="no-referrer" /> </v-avatar>
              <span class="mx-3 pt-3 align-middle" v-html="user.username"></span
            ></v-list-item-title>
          </v-list-item>
          <v-list-item @click="signOut">
            <v-list-item-title>
              <span class="mx-3 pt-3 align-middle">Deconnexion</span>
              <v-btn icon> <v-icon>mdi-logout</v-icon></v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn tile @click="$router.push('accueil')" text color="black" x-large>
        <v-icon left> mdi-arrow-left-bold </v-icon>
        Accueil
      </v-btn>
      <span class="text-h6">BDC Cérémonie</span>
      <v-spacer></v-spacer>
      <v-img
        class="d-none d-sm-block d-print-block mr-3"
        max-height="100"
        max-width="200"
        src="../components/logoMini.png"
      ></v-img>
      <v-spacer></v-spacer>
      <v-badge
        offset-x="25"
        offset-y="8"
        class="d-none d-lg-block d-print-block mr-9"
        bordered
        color="error"
        :content="nbBcdObs"
        :value="nbBcdObs"
        bottom
        overlap
      >
        <v-btn text depressed small @click="$router.push('bdcobs')"> BDC Obsèques </v-btn>
      </v-badge>
      <span class="text-caption">Montpellier {{ parisTime }}</span>
      <!-- <span class="ml-5 text-caption">Phuket {{ bangkokTime }}</span> -->
      <span class="ml-5 text-caption">Vegas {{ vegasTime }}</span>
    </v-app-bar>
    <v-progress-linear
      class="my-3"
      v-if="loading"
      color="blue"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
    <v-simple-table fixed-header height="92vh">
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              <span class="text-subtitle-1 text-left colorTitle mr-8">
                <strong>Action</strong>
              </span>
            </th>
            <th v-for="(key, index) in headers" class="text-left px-2" :key="index">
              <span class="text-subtitle-1 text-left colorTitle mr-8">
                <strong>{{ key }}</strong>
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(row, i) in dataFc">
            <tr :key="i" v-if="row.copieDansFC !== true">
              <!-- col c'est la valeur J c'est la clé -->
              <td>
                <v-btn
                  x-small
                  text
                  target="_blank"
                  :href="`https://gospel-bdc.web.app/?id=${row['id']}&admin=true`"
                >
                  <v-icon left>mdi-arrow-down-bold</v-icon>
                  Télécharger
                </v-btn>
                <bdc-form
                  :loading="loading"
                  :data="row"
                  :custumHeaders="headerLabel"
                  btnTitle="Modifier"
                  btnTitle2="Ajouter au fichier client"
                  :titre="`${row['groupe']}: ${row['nomVille']} ${row['cp']} `"
                  @dataSave="updateDataBcd($event)"
                  @dataSaveToFC="insertDataToFc($event)"
                ></bdc-form>
                <v-btn x-small text @click="deleteBdc(row)"
                  ><v-icon left color="red">mdi-delete-forever-outline</v-icon> Supprimer</v-btn
                >
              </td>
              <td v-for="(k, j) in headers" :key="j + i">
                {{ testIfitIsADate(row[k]) }}
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>
<script>
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getDatabase, ref, child, get } from "firebase/database";
import { formatInTimeZone } from "date-fns-tz";
import BdcForm from "./BdcForm.vue";
export default {
  name: "BDC",
  components: { BdcForm },
  data: () => ({
    nbBcdObs: 0,
    loading: true,
    dataFc: [],
    headerLabel: [],
    DataKeys: [],
    parisTime: "",
    bangkokTime: "",
    vegasTime: "",
    urlBcd:
      "https://script.google.com/macros/s/AKfycbxmvEnkdzCChrQ2SpD_A_UVx4QybDiiekE_gkVfrN2PZxgVByRuNPIUO3RtVM7AjDPo/exec",

    url: "https://script.google.com/macros/s/AKfycbxmvEnkdzCChrQ2SpD_A_UVx4QybDiiekE_gkVfrN2PZxgVByRuNPIUO3RtVM7AjDPo/exec",
  }),
  methods: {
    async deleteBdc(bdc) {
      // this.$set(bdc,)
      if (confirm("Supprimer le bon de commande")) {
        bdc.copieDansFC = true;
        await this.updateDataBcd(bdc);
      }
    },
    async getNbrBDCObs() {
      var vm = this;
      // this.loading = true;
      var url = this.urlBcd;
      var action = "read";
      var table = "bddObseques";
      var range = "F1:G";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          vm.nbBcdObs = da.data.filter((e) => {
            return e.e6 == 9 && e.copieDansFC !== true;
          }).length;
        }
      } catch (err) {
        console.log(err);
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
      //   this.getCatData();
      //   this.getCatData2();
    },
    async updateDataBcd(data) {
      data.fromApp = true;
      delete data.row;
      this.loading = true;
      console.log("updateDataBcd: ", data);
      this.loading = true;
      var url = this.url;
      var action = "update";
      var table = "bdd";
      var id = data.id;
      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&id=" +
        id +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      console.log(JSON.stringify(data));
      console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          console.log(da);
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      this.loading = false;
      console.log(this.loading);
      // this.$set(this.$store.state, "loading", false);
    },
    async insertDataToFc(data) {
      var vm = this;
      console.log("insertDataToFc ", data);
      var tableCorr = [];
      // get table correspondance
      this.loading = true;
      var url = this.url;
      var action = "read";
      var table = "Param BDC Cérémonies";
      var range = "H1:J";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        console.log(response);
        let da = await response.json();
        if (da.success == true) {
          tableCorr = da.data.filter((e) => e.idFC !== "");
          console.log(tableCorr);
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }

      /////////////////////////////////
      var resTraitement = {};
      tableCorr.map((e) => {
        console.log(e.idFC);
        var idBdc = e.idBdc.split(",");
        var value = "";
        idBdc.map((ee) => {
          console.log(e);
          if (e["ajouter les labels"] == true) {
            var headerName = undefined;
            vm.headerLabel.map((elem) => {
              if (elem["nomVariable"] == ee) {
                headerName = elem["label"];
              }
            });
            value = `${value}${value.length == 0 ? "" : "\n"}${headerName ?? ee}: ${data[ee]}`;
          } else {
            value = `${value}${value.length == 0 ? "" : " "}${data[ee]}`;
          }
        });
        value = value.trim();
        console.log(value);
        resTraitement[e.idFC] = value == "undefined" ? "" : vm.testIfitIsADate(value);
      });
      // create and get new Id
      url =
        "https://script.google.com/macros/s/AKfycbwIjT1OSz4z7W8uh0hUYR6OHw7o2YfSYZlLuBREHJZnUYfoLnbyJlI7ImlmLX73-w6Y6w/exec";
      action = "getNewId";
      querry = url + "?action=" + action;
      try {
        let response = await fetch(querry);
        console.log(response);
        let da = await response.json();
        if (da.success == true) {
          console.log(da);
          resTraitement.id = da.data;
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      resTraitement[
        "Précisions du BDC pour la FDR : "
      ] = `Lien Google Maps du lieu de la prestation : ${data["lienGoogleMapslieuCérémonie"]}
Adresse précise du lieu de la cérémonie : ${data["AdresselieuCérémonie"]}
Personne référente pour informer par SMS de l’arrivée du groupe :
Nom-Prénom: ${data["personneRefNomPrenom"]}     mobile: ${data["personneRefTel"]}      Quel lien familial/amical: ${data["personneRefLien"]}
Si vous avez une wedding planner, nous indiquer son nom, mail, téléphone: ${data["dureeCer"]}
Surprise pour l’un des mariés: ${data["surprise"]}
Nombre d’invités: ${data["nbInvites"]}
Autres demandes ou suggestions: ${data["autresDemandes"]}
Contact de la personne en charge de la sonorisation: ${data["nomPerGerSono"]}
A-t-elle confirmé qu’elle respectera parfaitement la FT: ${data["confRespFichTechSono"]}`;
      // console.log(resTraitement);
      // resTraitement['Dates prévues des règlements'] =
      var jourPrelevement =
        data["datePrelevement"] == "au 1er" ? 1 : data["datePrelevement"] == "au 15" ? 15 : 25;
      if (data["reglementType23"] === 0 && data["MONTANT30"] !== "0" && data["MONTANT30"] !== "") {
        resTraitement[
          "Dates prévues des règlements"
        ] = `2 prélèvements : ${data["MONTANT30"]}€  ${jourPrelevement}/${data["MOIS30"]}/${data["ANNÉE30"]}, ${data["MONTANT70"]}€  ${jourPrelevement}/${data["MOIS70"]}/${data["ANNÉE70"]}`;
      } else if (
        data["reglementType23"] === 1 &&
        data["MONTANT303"] !== "0" &&
        data["MONTANT303"] !== ""
      ) {
        resTraitement[
          "Dates prévues des règlements"
        ] = `3 prélèvements : ${data["MONTANT303"]}€ le ${jourPrelevement}/${data["MOIS303"]}/${data["ANNÉE303"]}, ${data["MONTANT403"]}€  ${jourPrelevement}/${data["MOIS403"]}/${data["ANNÉE403"]}, ${data["MONTANT30_3"]}€  ${jourPrelevement}/${data["MOIS30_3"]}/${data["ANNÉE30_3"]}`;
      } else if (
        data["reglementType23"] === -1 &&
        data["MONTANT100"] !== "0" &&
        data["MONTANT100"] !== ""
      ) {
        resTraitement[
          "Dates prévues des règlements"
        ] = `Prélèvement de ${data["MONTANT100"]}€ en une seule fois le ${jourPrelevement}/${data["MOIS100"]}/${data["ANNÉE100"]}`;
      } else {
        resTraitement[
          "Dates prévues des règlements"
        ] = `Erreur : mode de paiement non sélectionné 1 / 2 / 3 fois
          si 1 fois : 
          1 prélèvement : ${data["MONTANT100"]}€  ${jourPrelevement}/${data["MOIS100"]}/${data["ANNÉE100"]}
          si 2 fois :
          2 prélèvements : ${data["MONTANT30"]}€  ${jourPrelevement}/${data["MOIS30"]}/${data["ANNÉE30"]}, ${data["MONTANT70"]}€  ${jourPrelevement}/${data["MOIS70"]}/${data["ANNÉE70"]}
          si 3 fois : 
          3 prélèvements : ${data["MONTANT303"]}€ le ${jourPrelevement}/${data["MOIS303"]}/${data["ANNÉE303"]}, ${data["MONTANT403"]}€  ${jourPrelevement}/${data["MOIS403"]}/${data["ANNÉE403"]}, ${data["MONTANT30_3"]}€  ${jourPrelevement}/${data["MOIS30_3"]}/${data["ANNÉE30_3"]}

        `;
      }
      resTraitement["adressePostale"] = data["adressePostaleParticulier"];
      resTraitement["nomEtPrenomDuDefun"] = data["Nom et prénom du défun"] || "";
      //       if (data["MONTANT30"] !== 0) {
      //         resTraitement[
      //           "Dates prévues des règlements"
      //         ] = `Acompte 30% (à la commande) ${data["MONTANT30"]}€  ${data["datePrelevement"]}/${data["MOIS30"]}/${data["ANNÉE30"]}
      // Solde 70% (4 mois avant l'événement) ${data["MONTANT70"]}€  ${data["datePrelevement"]}/${data["MOIS70"]}/${data["ANNÉE70"]}`;
      //       } else {
      //         resTraitement[
      //           "Dates prévues des règlements"
      //         ] = `Acompte 30% (à la commande) ${data["MONTANT303"]}€  ${data["datePrelevement"]}/${data["MOIS303"]}/${data["ANNÉE303"]}
      // Solde 40% (4 mois avant l'événement) ${data["MONTANT403"]}€  ${data["datePrelevement"]}/${data["MOIS403"]}/${data["ANNÉE403"]}
      // Solde 30% (1 mois avant l'événement) ${data["MONTANT30_3"]}€  ${data["datePrelevement"]}/${data["MOIS30_3"]}/${data["ANNÉE30_3"]}`;
      //       }
      // injection dans le Fichier client
      url =
        "https://script.google.com/macros/s/AKfycbwIjT1OSz4z7W8uh0hUYR6OHw7o2YfSYZlLuBREHJZnUYfoLnbyJlI7ImlmLX73-w6Y6w/exec";
      action = "insertTop";
      table = "Mariages, répétitions et techn"; // a changer en "Mariages, répétitions et techn"
      querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&id=" +
        resTraitement.id +
        "&data=" +
        encodeURIComponent(JSON.stringify(resTraitement));
      console.log(querry);
      try {
        let response = await fetch(querry);
        console.log(response);
        let da = await response.json();
        if (da.success == true) {
          console.log(da);
          resTraitement.id = da.data;
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // modification dans BDC pour ne plus l'afficher
      data.copieDansFC = true;
      vm.updateDataBcd(JSON.parse(JSON.stringify(data)));
      this.loading = false;
    },

    async getData() {
      await this.getDataKeys(this.user.email);
      var vm = this;
      this.loading = true;
      var url = this.url;
      var action = "read";
      var table = "bdd";
      var range = "A1:BO";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          console.log(da);
          vm.dataFc = da.data.filter((e) => {
            return e.e6 == 9;
          });
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      this.loading = false;
    },
    async getDataKeys(id) {
      console.log(id);
      var vm = this;
      this.loading = true;
      var url = this.url;
      var action = "read";
      var table = "param";
      var range = "A1:D10";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range + "&id=" + id;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        console.log(da);
        if (da.success == true) {
          if (!da.data) {
            vm.DataKeys = {
              Tableau: "groupe,nomVille,cp,Nom,Prénom,date",
              Formulaire: "id,Date de la prestation,Date initiale,Groupe,Lieu,tarif de vente TTC",
            };
          } else {
            vm.DataKeys = da.data;
          }
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      false;
    },
    async getHeaderLabel() {
      var vm = this;
      this.loading = true;
      var url = this.url;
      var action = "read";
      var table = "Param BDC Cérémonies";
      var range = "A1:B";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        console.log(da);
        if (da.success == true) {
          vm.headerLabel = da.data.filter((e) => e["nomVariable"] !== "");
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
    },

    testIfitIsADate(date) {
      if (isNaN(Date.parse(date)) || String(date).length < 6) {
        //not a date
        return date;
      } else {
        // is a date => format
        return this.formatDate(date);
      }
    },
    formatDate(date) {
      if (!date) return date;
      if (!new RegExp("T.+Z").test(date)) return date;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },

    signOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          window.alert("déconnexion réussie");
        })
        .catch((error) => {
          window.alert(`Erreur: ${error}`);
        });
    },
    updateClock() {
      var date = new Date();
      this.parisTime = formatInTimeZone(date, "Europe/Paris", "HH:mm");
      this.bangkokTime = formatInTimeZone(date, "Asia/Bangkok", "HH:mm");
      this.vegasTime = formatInTimeZone(date, "America/Los_Angeles", "HH:mm");
      requestAnimationFrame(this.updateClock);
    },
    calculateRows(kk) {
      var a = this.visibleRow[kk];
      if (a == undefined) {
        return 6;
      }
      return a.toString().length > 300 ? 12 : 6;
    },
    calculateRows2(kk) {
      var a = this.visibleRow[kk];
      if (a == undefined) {
        return 3;
      }
      return a.toString().length > 80 ? 12 : a.toString().length > 200 ? 6 : 3;
    },
  },
  computed: {
    keys() {
      return Object.keys(this.dataFc[0]);
    },
    user() {
      return JSON.parse(JSON.stringify(this.$store.state.currentUser.dataFromGoogleAuth));
    },
    headers() {
      if (this.DataKeys.Tableau) {
        return this.DataKeys.Tableau.split(",");
      } else {
        return [];
      }
    },
    formKeys() {
      if (this.DataKeys.Tableau) {
        return this.DataKeys.Formulaire.split(",");
      } else {
        return [];
      }
    },
  },
  mounted() {
    document.title = "BDC Cérémonies";
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log(user.uid);
        const dbRef = ref(getDatabase());
        get(child(dbRef, `users/${user.uid}`))
          .then((snapshot) => {
            if (snapshot.exists()) {
              var userData = snapshot.val();
              console.log(userData);
              if (userData.status == "") {
                window.alert("Votre compte est en cours de validation ...");
                this.$router.push("/login");
              } else {
                this.$store.state.currentUser.status = userData.status;
                this.$store.state.currentUser.dataFromGoogleAuth = userData;
                this.getData();
                this.getHeaderLabel();
              }
            } else {
              console.log("userData");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$router.push("/login");
      }
    });
    this.getNbrBDCObs();
    requestAnimationFrame(this.updateClock);
  },
};
</script>
<style>
.v-messages__message {
  color: #1565c0;
}
.colorTitle {
  color: #1a237e;
}
.bd-highlight {
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.15);
}
.v-icon.v-icon {
  font-size: 20px !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 11px !important;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 5px !important;
}
.v-list-item__action {
  align-self: center;
  margin: 0px 0;
}
.v-list-item {
  padding: 0 6px;
}
.v-menu__content .theme--light .menuable__content__active {
  min-width: 197px !important;
}
</style>
